module.exports = __webpack_public_path__ + "img/logo.80cedeb3.png";